import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var passwordBaseTextField = 'fx_2d2fb1e5_sregt60';
var passwordIconRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_sregt61',variantClassNames:{size:{small:'fx_2d2fb1e5_sregt62','default':'fx_2d2fb1e5_sregt63',large:'fx_2d2fb1e5_sregt64',xlarge:'fx_2d2fb1e5_sregt65'}},defaultVariants:{},compoundVariants:[]});
var passwordTypeToggleButton = 'fx_2d2fb1e5_sregt66';

export { passwordBaseTextField, passwordIconRoot, passwordTypeToggleButton };
//# sourceMappingURL=passwordTextField.vanilla.mjs.map
